import {WZListItem} from "./types";
import {isWZReturn} from "../helpers";

function isWZList(value: unknown): value is WZListItem[] {
    return Array.isArray(value);
}

export function normalizeWZResponse(response: unknown): WZListItem[] {
    if (!isWZList(response)) {
        return [];
    }

    return response.map((item) => {
        const rawItem = item as WZListItem & {
            return?: unknown;
            is_return?: unknown;
            'is-return'?: unknown;
        };
        const returnValue = rawItem.isReturn ?? rawItem.return ?? rawItem.is_return ?? rawItem['is-return'];

        return {
            ...item,
            isReturn: isWZReturn(returnValue),
        };
    });
}
